// Flags from https://github.com/Yummygum/flagpack-core
import { FlexRow } from "@@/shared/flex-containers";
import { useTheme } from "@emotion/react";
import type { RemSize } from "@towni/common";

type Props = {
    readonly className?: string;
    readonly size: number | RemSize;
};

const LanguageFlag_sv = (props: Props) => {
    const theme = useTheme();
    const size = props.size ?? 1;
    return (
        <FlexRow
            mainAxis="center"
            crossAxis="center"
            className={props.className}
            style={{
                backgroundColor: theme.colors.default.background.asString,
                width: `${size}rem`,
                height: `${(size ?? 1) * 0.75}rem`,
            }}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 32 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_270_67496)">
                    <rect width="32" height="24" fill="white" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0V24H32V0H0Z"
                        fill="#3D58DB"
                    />
                    <mask
                        id="mask0_270_67496"
                        style={{
                            maskType: "luminance",
                        }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="32"
                        height="24">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0 0V24H32V0H0Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask0_270_67496)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10 0H14V10H32V14H14V24H10V14H0V10H10V0Z"
                            fill="#FECA00"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_270_67496">
                        <rect width="32" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </FlexRow>
    );
};

export { LanguageFlag_sv };
